// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dk-0";
export var actionModalContentContainer = "_dk-1";
export var createTagButton = "_dk-2";
export var footerContainer = "_dk-7";
export var fullWidthDivider = "_dk-3";
export var hasCreateTagButton = "_dk-4";
export var noCreateTagButton = "_dk-5";
export var tagsContainer = "_dk-6";
export var tagsModalContentContainer = "_dk-8";